import styled from '@emotion/styled';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { navigationService } from 'src/config/rootService';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';
import img from 'src/public/img/request_submitted.svg';
import { Button } from 'src/shared/components/Button';
import { color, font } from 'src/shared/styles/variables';

const Wrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: 1000,
});

const Title = styled.h3({
    textAlign: 'center',
    marginTop: 20,
    marginBottom: 11,
    color: color.pickledBluewood,
    ...font.black(font.size.extraLarge),
});

const Description = styled.h5({
    textAlign: 'center',
    color: color.steelGray,
    marginBottom: 16,
    ...font.book(font.size.medium),
});

const Box = styled.div({
    maxWidth: 510,
    width: '100%',
    padding: '32px 30px',
    border: `2px solid ${color.linkWaterLight}`,
    boxShadow: '0px 4px 10px rgba(208, 209, 210, 0.5)',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
});

const BoxBoldText = styled.span({
    color: color.pickledBluewood,
    textAlign: 'center',
    ...font.heavy(font.size.base),
});

const BoxRegularText = styled.span({
    color: color.steelGray,
    marginTop: 12,
    textAlign: 'center',
    ...font.medium(font.size.base),
});

const BoxEmailAddress = styled.span({
    color: color.royalBlue,
    padding: '7px 14px',
    margin: '10px auto 12px',
    textAlign: 'center',
    background: color.zircon,
    border: `2px solid ${color.zircon}`,
    borderRadius: 4,
    ...font.heavy(font.size.base),
});

const ButtonWrapper = styled.div({
    maxWidth: 510,
    marginTop: 32,
    width: '100%',
});

export enum WorkWithTherapistRequestSentTestId {
    Confirm = 'WorkWithTherapistRequestSentTestId.Confirm',
}

export const WorkWithTherapistRequestSent: React.FC = () => {
    const { t } = useTranslation();
    const user = useSelector(getUserInformation);

    return (
        <Wrapper>
            <img src={img} alt="" />
            <Title>{t('providers:therapist_request_sent.title')}</Title>
            <Description>{t('providers:therapist_request_sent.description')}</Description>

            <Box>
                <BoxBoldText>{t('providers:therapist_request_sent.send_email')}</BoxBoldText>
                <BoxEmailAddress>{user.email}</BoxEmailAddress>
                <BoxRegularText>
                    <Trans
                        t={t}
                        ns="providers"
                        i18nKey="therapist_request_sent.back_information"
                        components={{
                            days: <BoxBoldText />,
                        }}
                    />
                </BoxRegularText>
                <BoxRegularText>{t('providers:therapist_request_sent.inbox')}</BoxRegularText>
            </Box>

            <ButtonWrapper>
                <Button
                    testID={WorkWithTherapistRequestSentTestId.Confirm}
                    onClick={() => navigationService.navigate('/')}
                    fullWidth
                    withShadow
                >
                    {t('providers:therapist_request_sent.confirm')}
                </Button>
            </ButtonWrapper>
        </Wrapper>
    );
};
